/* eslint-disable */
import axios from "axios";
import CRC32 from "crc-32";
import { OAS_API_BASE_URL as baseUrlArr } from "../configuration";
import {
  decryptData,
  encryptData,
  forceFullyLogoutAPI,
} from "../common/actions/commonActions";
import { SECRET_KEY } from "../configuration";
import {
  HAS_PENDING_TRANSACTIONS,
  RECONCILE_NOW,
  BILLDESK,
  EASEBUZZ_CALLBACK,
  EASEBUZZ_EPAY,
  API_APPLICATION_RECEIPT,
  PAYMENTDETAILS,
  PAYNOW,
  SBIEPAY,
  QUIKWALLET_EPAY,
  QUIKWALLET_EPAY_RETOTALING,
  PAYNOW_RETOTALING,
  SBIEPAY_RETOTALING,
  EASEBUZZEPAY_RETOTALING,
  SBIEPAY_OBJECTION_REQUEST,
  QUIKWALLET_EPAY_OBJECTION_REQUEST,
  EASEBUZZEPAY_OBJECTION_REQUEST,
  BILLDESK_OBJECTION_REQUEST,
  CSC_OBJECTION_REQUEST,
  BILLDESK_RETOTALING,
  ADVERTISEMENT_PDF,
  PHOTO_URL,
  UPLOAD_DOCUMENT,
  UPLOADIMAGEREQ,
  API_CHALLAN_SLIP,
  DOWNLOADCORRESPONDENCEDOC,
  DOWNLOADMARKSHEET,
  DOWNLOAD_DOCUMENT,
  GETOBJECTIONREQUEST,
  API_CHALLAN_PAYMENT_RECEIPT,
  PROFILE_SUMMARY,
  PROFILE_INFO_DISPLAY,
  API_REPO_VERSION,
  FORCEFULLY_LOGOUT,
  ADDOBJECTIONREQUEST,
  GRIEVANCE_SAVE,
  APPLICATIONS,
  LIVE_PHOTO_DRAFT_API,
  GET_ADMIN_GRIEVANCE_LIST,
  GET_ADMIN_GRIEVANCE_SINGLE_LIST,
  APPLICATION_PDF_GENERATE_API,
  UPLOAD_CANDIDATE_LIST,
  ADMIT_CARD_TEMPLATE,
  DOWNLOAD_EXAM_STAFF_SAMPLE_FILE,
  UPLOAD_EXAM_STAFF_DATA,
  GET_PROFILE_CREATION_DRAFT_DATA,
  GET_PROFILES_SUMMARY_DATA,
  UPLOAD_OBJECTION_FILE,
  DOWNLOAD_RETOTALING_REQUEST,
  MARKSHEETTEMPLATE,
  UPLOADMARKSHEET,
  DOWNLOAD_INTERVIEW_PT_LETTER_SAMPLE_FILE,
  UPLOAD_INTERVIEW_PT_LETTER_CSV_FILE,
  GET_ELIGIBLE_CANDIDATES_SAMPLE_FILE,
  UPLOAD_ELIGIBLE_CANDIDATES_FILE,
  DOWNLOAD_MUSTER_REPORT
  
} from "../common/constants/endpoints";
import { toastr } from "react-redux-toastr";
import commonLabels from "../common/labels/common_en.json";
import { SET_GRIEVANCE_TABLE_LIST } from "../common/constants/ActionTypes";

let baseURL = "api.bpsconline.gov.in";
const currentDomain = window.location.hostname;
let logoutTriggered = false;
let invalidAccessFlg = false;
let objectByIdUrl = "/oas/api/v1/objection?id";
let objectionFileData="/oas/api/v1/admin/objectionfiles?filename";

baseUrlArr &&
  baseUrlArr.length > 0 &&
  baseUrlArr.filter((e) => {
    if (currentDomain === e.key) {
      baseURL = e.value;
      axios.defaults.baseURL = e.baseUrl;
    }
  });

export function generateCRC() {
  const dataWithSecret = SECRET_KEY;
  // const localCrcValue = CRC32.str(dataWithSecret).toString(16);
  // config.headers['Access-Control-Allow-OAS'] = unsignedCrcValue;
  const crcValue = CRC32.str(dataWithSecret);
  const unsignedCrcValue = (crcValue >>> 0).toString(16);
  return unsignedCrcValue;
}
const axiosInstance = axios.create({
  headers: {
    "Content-Type": "application/json",
    "Content-Security-Policy": "default-src 'self'; script-src 'self; 'frame-ancestors 'none';",
    "Strict-Transport-Security": "max-age=31536000; includeSubDomains; preload",
    "X-Content-Type-Options": "nosniff",
    "X-Frame-Options": "DENY",
    "Referrer-Policy": "no-referrer-when-downgrade"
  },
  responseType: "json",
});
axiosInstance.interceptors.request.use(
  (config) => {
    const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
    const token = session?.jwtResponse?.token;
    const excludedEndpoints = [
      HAS_PENDING_TRANSACTIONS,
      RECONCILE_NOW,
      BILLDESK,
      EASEBUZZ_CALLBACK,
      EASEBUZZ_EPAY,
      API_APPLICATION_RECEIPT,
      PAYMENTDETAILS,
      PAYNOW,
      SBIEPAY,
      QUIKWALLET_EPAY,
      QUIKWALLET_EPAY_RETOTALING,
      PAYNOW_RETOTALING,
      SBIEPAY_RETOTALING,
      EASEBUZZEPAY_RETOTALING,
      SBIEPAY_OBJECTION_REQUEST,
      QUIKWALLET_EPAY_OBJECTION_REQUEST,
      EASEBUZZEPAY_OBJECTION_REQUEST,
      BILLDESK_OBJECTION_REQUEST,
      CSC_OBJECTION_REQUEST,
      BILLDESK_RETOTALING,
      ADVERTISEMENT_PDF,
      PHOTO_URL,
      UPLOAD_DOCUMENT,
      UPLOADIMAGEREQ,
      API_CHALLAN_SLIP,
      DOWNLOADCORRESPONDENCEDOC,
      DOWNLOADMARKSHEET,
      DOWNLOAD_DOCUMENT,
      GETOBJECTIONREQUEST,
      API_CHALLAN_PAYMENT_RECEIPT,
      PROFILE_SUMMARY,
      PROFILE_INFO_DISPLAY,
      API_REPO_VERSION,
      objectByIdUrl,
      GRIEVANCE_SAVE,
      APPLICATIONS,
      LIVE_PHOTO_DRAFT_API,
      GET_ADMIN_GRIEVANCE_LIST,
      GET_ADMIN_GRIEVANCE_SINGLE_LIST,
      APPLICATION_PDF_GENERATE_API,
      UPLOAD_CANDIDATE_LIST,
      ADMIT_CARD_TEMPLATE,
      DOWNLOAD_EXAM_STAFF_SAMPLE_FILE,
      UPLOAD_EXAM_STAFF_DATA,
      GET_PROFILE_CREATION_DRAFT_DATA,
      GET_PROFILES_SUMMARY_DATA,
      UPLOAD_OBJECTION_FILE,
      objectionFileData,
      DOWNLOAD_RETOTALING_REQUEST,
      MARKSHEETTEMPLATE,
      UPLOADMARKSHEET,
      DOWNLOAD_INTERVIEW_PT_LETTER_SAMPLE_FILE,
      UPLOAD_INTERVIEW_PT_LETTER_CSV_FILE,
      GET_ELIGIBLE_CANDIDATES_SAMPLE_FILE,
      UPLOAD_ELIGIBLE_CANDIDATES_FILE,
      DOWNLOAD_MUSTER_REPORT
    ];
    const isExcludedEndpoint = excludedEndpoints.some((endpoint) =>
      config.url.includes(endpoint)
    );
    if (token && !FORCEFULLY_LOGOUT) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    if (config.headers["Content-Type"] === "multipart/form-data") {
      return config;
    }

    if (
      config.method !== "get" &&
      config.data &&
      !config.data.encryptedReqBody &&
      !isExcludedEndpoint
    ) {

      config.data = {
        encryptedReqBody: encryptData(JSON.stringify(config.data)),
      };
    }
    if(config.method === "delete"){
      config.headers["Access-Control-Allow-OAS"] = generateCRC();
    }else 
    if (config.method !== "get") {
      let dataWithSecret = "";
      let excludedUrl = [
        EASEBUZZEPAY_OBJECTION_REQUEST,
        SBIEPAY_OBJECTION_REQUEST,
        BILLDESK_OBJECTION_REQUEST,
        QUIKWALLET_EPAY_OBJECTION_REQUEST,
        CSC_OBJECTION_REQUEST,
        EASEBUZZEPAY_RETOTALING,
        BILLDESK_RETOTALING,
        SBIEPAY_RETOTALING,
        PAYNOW_RETOTALING,
        QUIKWALLET_EPAY_RETOTALING,
        LIVE_PHOTO_DRAFT_API,
        GET_ADMIN_GRIEVANCE_LIST,
        GET_ADMIN_GRIEVANCE_SINGLE_LIST,
        APPLICATION_PDF_GENERATE_API,
        UPLOAD_CANDIDATE_LIST,
        ADMIT_CARD_TEMPLATE,
        DOWNLOAD_EXAM_STAFF_SAMPLE_FILE,
        UPLOAD_EXAM_STAFF_DATA,
        GET_PROFILE_CREATION_DRAFT_DATA,
        GET_PROFILES_SUMMARY_DATA,
        UPLOAD_OBJECTION_FILE,
        DOWNLOAD_RETOTALING_REQUEST,
        MARKSHEETTEMPLATE,
        UPLOADMARKSHEET,
        DOWNLOAD_INTERVIEW_PT_LETTER_SAMPLE_FILE,
        UPLOAD_INTERVIEW_PT_LETTER_CSV_FILE,
        GET_ELIGIBLE_CANDIDATES_SAMPLE_FILE,
        UPLOAD_ELIGIBLE_CANDIDATES_FILE,
        DOWNLOAD_MUSTER_REPORT
      ];
      const isExcludedUrls = excludedUrl.some((endpoint) =>
        config.url.includes(endpoint)
      );

      if (config.method === "post" && isExcludedUrls) {
        dataWithSecret = encryptData(JSON.stringify(config.data)) + SECRET_KEY;
      } else {
        dataWithSecret =
          Object.keys(config.data).length === 0
            ? encryptData("{}") + SECRET_KEY
            : config.data.encryptedReqBody + SECRET_KEY;
      }
      const crcValue = CRC32.str(dataWithSecret);
      const unsignedCrcValue = (crcValue >>> 0).toString(16);
      config.headers["Access-Control-Allow-OAS"] = unsignedCrcValue;
    } else {
      config.headers["Access-Control-Allow-OAS"] = generateCRC();
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor for decryption od data
axiosInstance.interceptors.response.use(
  (response) => {

    const excludedEndpoints = [
      HAS_PENDING_TRANSACTIONS,
      RECONCILE_NOW,
      BILLDESK,
      EASEBUZZ_CALLBACK,
      EASEBUZZ_EPAY,
      API_APPLICATION_RECEIPT,
      PAYMENTDETAILS,
      PAYNOW,
      SBIEPAY,
      QUIKWALLET_EPAY,
      QUIKWALLET_EPAY_RETOTALING,
      PAYNOW_RETOTALING,
      SBIEPAY_RETOTALING,
      EASEBUZZEPAY_RETOTALING,
      SBIEPAY_OBJECTION_REQUEST,
      QUIKWALLET_EPAY_OBJECTION_REQUEST,
      EASEBUZZEPAY_OBJECTION_REQUEST,
      BILLDESK_OBJECTION_REQUEST,
      CSC_OBJECTION_REQUEST,
      BILLDESK_RETOTALING,
      ADVERTISEMENT_PDF,
      PHOTO_URL,
      UPLOAD_DOCUMENT,
      UPLOADIMAGEREQ,
      API_CHALLAN_SLIP,
      DOWNLOADCORRESPONDENCEDOC,
      DOWNLOADMARKSHEET,
      DOWNLOAD_DOCUMENT,
      GETOBJECTIONREQUEST,
      API_CHALLAN_PAYMENT_RECEIPT,
      PROFILE_SUMMARY,
      PROFILE_INFO_DISPLAY,
      API_REPO_VERSION,
      objectByIdUrl,
      GRIEVANCE_SAVE,
      LIVE_PHOTO_DRAFT_API,
      GET_ADMIN_GRIEVANCE_LIST,
      GET_ADMIN_GRIEVANCE_SINGLE_LIST,
      // APPLICATIONS
      APPLICATION_PDF_GENERATE_API,
      UPLOAD_CANDIDATE_LIST,
      ADMIT_CARD_TEMPLATE,
      DOWNLOAD_EXAM_STAFF_SAMPLE_FILE,
      UPLOAD_EXAM_STAFF_DATA,
      GET_PROFILE_CREATION_DRAFT_DATA,
      GET_PROFILES_SUMMARY_DATA,
      UPLOAD_OBJECTION_FILE,
      objectionFileData,
      DOWNLOAD_RETOTALING_REQUEST,
      MARKSHEETTEMPLATE,
      UPLOADMARKSHEET,
      DOWNLOAD_INTERVIEW_PT_LETTER_SAMPLE_FILE,
      UPLOAD_INTERVIEW_PT_LETTER_CSV_FILE,
      GET_ELIGIBLE_CANDIDATES_SAMPLE_FILE,
      UPLOAD_ELIGIBLE_CANDIDATES_FILE,
      DOWNLOAD_MUSTER_REPORT
    ];
    const isExcludedEndpoint = excludedEndpoints.some((endpoint) =>
      response.config.url.includes(endpoint)
    );
    if (
      response.data &&
      !isExcludedEndpoint &&
      !(
        (response.config.method === "patch" ||
          response.config.method === "post") &&
        ((response.config.url === "/oas/api/v1/objection") || (response.config.url === "/oas/api/v1/admin/objectionfiles"))
      )
      &&
      !(
        (
          response.config.method === "get") &&
          response.config.url.includes("/oas/api/v1/admin/objectionfiles?filename")
      )
      &&
      !(
        (response.config.method === "patch" ||
          response.config.method === "post") &&
        response.config.url === "/oas/api/v1/applications"
      )
    ) {

      const jsonString = response.data;
      const dataWithSecret = jsonString + SECRET_KEY;
      const crcValue = CRC32.str(dataWithSecret);
      const frontendCrcValue = (crcValue >>> 0).toString(16);
      let backendCrcValue = response.headers["access-control-allow-oas"];
      if (frontendCrcValue !== backendCrcValue) {
        try {
          toastr.error(commonLabels.COMMON.INVALID_ACCESS);
          forceFullyLogoutAPI('', true);
        } catch (error) {
          console.error(commonLabels.COMMON.ERR_RES_MES, error.response);
        }
      }
    } else if (response.data && isExcludedEndpoint) {

      let jsonString = "";
      if (typeof response.data === "string") {

        jsonString = encryptData(response.data);
      }
      // else if(typeof response.data === "object")
      //   {
      //     try {

      //       response.data = JSON.parse(decryptData(response.data));
      //     } catch (error) {

      //       response.data = decryptData(response.data);
      //     }
      //   }
      else {

        jsonString = encryptData(JSON.stringify(response.data));
      }
      if (response.config.url === "/oas/api/v1/applications") {
        try {
          response.data = JSON.parse(decryptData(response.data));
        } catch (error) {

          response.data = decryptData(response.data);
        }
      }
    }
    if (response.data && !isExcludedEndpoint && !(
      (response.config.method === "patch" ||
        response.config.method === "post") &&
      response.config.url === "/oas/api/v1/applications"
    )) {
      try {
        response.data = JSON.parse(decryptData(response.data));
      } catch (error) {
        response.data = decryptData(response.data);
      }
    }
    return response;
  },
  (error) => {
    if (error.response) {
      if (
        error.response.status === 500 &&
        !logoutTriggered &&
        error.response.data &&
        error.response.data.message &&
        error.response.data.message === commonLabels.COMMON.RELOGIN_MES
      ) {
        logoutTriggered = true;
        try {

          forceFullyLogoutAPI('', true);
        } catch (error) {
          console.error(commonLabels.COMMON.ERR_RES_MES, error.response);
        }
      }

      if (
        error.response.status === 400 &&
        !invalidAccessFlg &&
        error.response.data &&
        error.response.data.message &&
        error.response.data.message ===
        commonLabels.COMMON.CRC_VALUE_DOES_NOT_MATCH
      ) {
        invalidAccessFlg = true;
        try {

          forceFullyLogoutAPI('', true);
        } catch (error) {
          console.error(commonLabels.COMMON.ERR_RES_MES, error.response);
        }
      }
    }
    return Promise.reject(error);
  }
);
export const axiosInstanceWithoutEncrDecr = axios.create({
  headers: {
    "Content-Type": "application/json",
    "Content-Security-Policy": "default-src 'self'; script-src 'self; 'frame-ancestors 'none';",
    "Strict-Transport-Security": "max-age=31536000; includeSubDomains; preload",
    "X-Content-Type-Options": "nosniff",
    "X-Frame-Options": "DENY",
    "Referrer-Policy": "no-referrer-when-downgrade",
    "Access-Control-Allow-OAS": generateCRC(),
  },
  responseType: "json",
});
export default axiosInstance;
